import { useSelector } from 'react-redux';

import { isUgcGames, isContestGamesWithSecondaryUgc } from 'config/promoGameTypes';
import { IS_PROMO_FLOW } from 'config/envVariable';

export default function useIsContestUgcModule() {
    const { type: gameType } = useSelector(s => s.promo);
    const secondaryGameType = useSelector(s => s.relatedTwinsPromo?.promo?.type);
    const isContestUgcModule = IS_PROMO_FLOW
        ? isUgcGames(gameType) && isContestGamesWithSecondaryUgc(secondaryGameType)
        : isUgcGames(secondaryGameType) && isContestGamesWithSecondaryUgc(gameType);
    return isContestUgcModule;
}
